<template>
  <div class="dashboard-container">
    <div class="dashboard-header">
      <h1 class="welcome-title">Сайн байна уу? <span class="user-name">{{ this.user.lastName }}</span></h1>
      <p class="welcome-subtitle">Тавтай морилно уу</p>
    </div>
    <el-row :gutter="16" justify="center" class="stats-row">
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <div class="stat-card stat-card-primary" @click="changeDataOpen('yuan')">
          <div class="stat-icon stat-icon-primary">
            <font-awesome-icon icon="yen-sign" />
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ active_config.yuan }}₮</div>
            <div class="stat-label">Нэг юанийг тооцох төгрөгийн дүн</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
        <div class="stat-card stat-card-success" @click="changeDataOpen('teevriin_huls')">
          <div class="stat-icon stat-icon-success">
            <font-awesome-icon icon="weight-hanging" />
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ $formatCurrencyComma(active_config.teevriin_huls) }}₮</div>
            <div class="stat-label">1 митр куб ачаа тээвэрлэх үнэ</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="row-bg" justify="center">
      <el-col :span="22" class="mt-10 w-100">
        <el-card class="config-history-card" shadow="hover">
          <template #header>
            <div class="card-header">
              <span class="card-title">
                <font-awesome-icon icon="clock-rotate-left" class="card-title-icon" />
                Тохиргооны түүх
              </span>
            </div>
          </template>
          <el-table class="modern-table" v-if="data.length > 0" :data="data" :row-class-name="tableRowClassName" stripe>
          <el-table-column align="center" label="№" type="index" class="table_style"></el-table-column>
          <el-table-column align="center" label="Юань" prop="yuan">
            <template #default="scope">
              {{ $formatCurrency(scope.row.yuan) }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="Тээврийн хөлс /м3/" prop="teevriin_huls">
            <template #default="scope">
              {{ $formatCurrency(scope.row.teevriin_huls) }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="Огноо">
            <template #default="scope">
              {{ new Date(scope.row.createdAt).toLocaleDateString() }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="Төрөл">
            <template #default="scope">
              <p v-if="scope.row.type === 'transportation'">Тээвэр</p>
              <p v-if="scope.row.type === 'delivery'">Хүргэлт</p>
            </template>
          </el-table-column>
          <el-table-column align="center" label="Идэвхитэй эсэх">
            <template #default="scope">
              <el-switch @change="changeStatus(scope.row)" v-model="scope.row.is_active" inline-prompt style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ff4949" active-text="Идэвхтэй" inactive-text="Идэвхгүй"></el-switch>
            </template>
          </el-table-column>
          <el-table-column align="center" label="Үйлдэл"
            v-if="checkPermissionsPage('admin')">
            <template v-slot="scope">
              <el-button @click="configDetail(scope.row)" type="primary">Дэлгэрэнүй</el-button>
              <!-- <font-awesome-icon @click="configDetail(scope.row)" icon="plus" style="color: #007BFF; font-size: 30px; margin-right: 10px; cursor: pointer;" /> -->
              <!-- <font-awesome-icon @click="configTypeListDrawer(scope.row)" icon="list" style="color: #007BFF; font-size: 30px; cursor: pointer;" /> -->
            </template>
          </el-table-column>
        </el-table>
        <p v-else>Өгөгдөл байхгүй байна.</p>
        <!-- Pagination -->
         <el-pagination
            @current-change="handlePageChange"
            :current-page="currentPage"
            :page-size="pageSize"
            :total="totalRecords"
            layout="total, prev, pager, next, jumper"
            class="modern-pagination" />
          <div class="card-footer">
            <el-button
              v-if="checkPermissionsPage('admin')"
              @click="createConfigDialogOpen()"
              type="primary"
              class="add-button"
              size="large"
            >
              <font-awesome-icon icon="plus" class="button-icon" />
              Өгөгдөл нэмэх
            </el-button>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!-- <el-drawer v-model="configDetailDrawer" title="Тохиргоотой холбоотой төрлүүд" direction="rtl">
      <div class="config_detail_area">
        <div v-if="selectConfig.ConfigType.length === 0">
          <el-image style="width: 100px; height: 100px" :src="url" fit="fill" /><br>
          <span>Тохиргоонд хамаарах төрөл хоосон байна.</span>
        </div>
        <div v-else>
          <el-card v-for="item,index in selectConfig.ConfigType" :key="index">
            <el-descriptions :title="item.name">
              <el-descriptions-item label="Нэр:">{{ item.name }}</el-descriptions-item>
              <el-descriptions-item label="Тайлбар:">{{ item.description }}</el-descriptions-item>
              <el-descriptions-item label="Эзэлхүүн оролцох:">
                <el-tag size="small">{{ item.is_ezelhvvn }}</el-tag>
              </el-descriptions-item> <br />
              <el-descriptions-item label="Хэмжигдэхүүн үнэ">
                <el-row v-for="element,index in item.ConfigReferences" :key="index">
                  <el-col :span="7">
                    Бага : {{ element.min }}
                  </el-col>
                  <el-col :span="7">
                    Их : {{ element.max }}
                  </el-col>
                  <el-col :span="7">
                    Хэмжээний үнэ : {{ element.price }}
                  </el-col>
                </el-row>
                <el-button class="mt-5" type="info" @click="editConfigType(item)">Засах</el-button>
              </el-descriptions-item>
            </el-descriptions>
          </el-card>
        </div>
      </div>
      <template #footer>
        <div style="flex: auto">
          <el-button class="w-100" type="success" @click="editConfigType()">Үүсгэх</el-button>
        </div>
      </template>
    </el-drawer> -->
    <CreateConfigDialog />
    <CreateConfigDetail :selectConfig="this.selectConfig" />
    <ChangeDataDialog :selectedConfig="active_config" :transferValue="this.shiljvvlehUtga" />
  </div>
</template>

<script>
import services from '@/services'
import { ElMessage } from 'element-plus'
import { mapGetters, mapActions } from 'vuex'
import CreateConfigDialog from './createConfigDialog.vue'
import ChangeDataDialog from './changeDataDialog.vue'
import { checkPermissions } from '@/helpers/custom'
import CreateConfigDetail from './createConfigDetail.vue'
import urlempty from '@/assets/empty.png'

export default {
  name: 'DashboardPage',
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  components: {
    CreateConfigDialog,
    CreateConfigDetail,
    ChangeDataDialog
  },
  data () {
    return {
      totalRecords: 0,
      data: [{
        yuan: null,
        teevriin_huls: null,
        ConfigReferences: {
          min: null,
          max: null,
          price: null
        }
      }],
      selectConfig: {},
      url: urlempty,
      currentPage: 1,
      pageSize: 10,
      shiljvvlehUtga: null,
      active_config: {}
    }
  },
  created () {
    this.loadData()
    this.getActiveConfig('transportation')
  },
  methods: {
    ...mapActions(['setCreateConfigDialog', 'setCreateYuanDialog',
      'setChangeHereglegchTootsohDunDialog', 'setChangeDoodJinTootsohDunDialog',
      'setChangeTeeveriinUneTootsoolohDoodJinDialog', 'setCreateConfigDetailDialog',
      'setChangeMitrKubAchaaTeeverlehUneDialog', 'setChangeDataDialog'
    ]),
    tableRowClassName ({
      row,
      rowIndex
    }) {
      if (rowIndex === 1) {
        return 'success-row'
      }
      return ''
    },
    checkPermissionsPage (data) {
      return checkPermissions(data)
    },
    handlePageChange (page) {
      this.currentPage = page // Одоогийн хуудсыг шинэчилнэ
      this.loadData() // Шинэ хуудсын өгөгдлийг татна
    },
    async loadData () {
      try {
        const response = await services.get('configs', {
          params: {
            page: this.currentPage,
            limit: this.pageSize
          }
        })
        if (response) {
          this.data = response.data
          this.totalRecords = response.total
          this.totalPages = response.totalPages
        } else {
          ElMessage.warning('Өгөгдөл олдсонгүй!')
        }
      } catch (error) {
        console.error('Error fetching data: ', error)
        ElMessage.error(`Өгөгдөл ачаалахад алдаа гарлаа: ${error.message}`)
      }
    },
    // viewDetails (row) {
    //   console.log('Дэлгэрэнгүй мэдээлэл:', row)
    //   ElMessage.info('Дэлгэрэнгүй мэдээлэл харагдаж байна!')
    // },
    // editConfigType (data) {
    //   this.editSelectConfigType = data
    //   this.setCreateConfigDetailDialog(true)
    // },
    configDetail (data) {
      this.selectConfig = data
      this.setCreateConfigDetailDialog(true)
    },
    // configTypeListDrawer (data) {
    //   this.configDetailDrawer = true
    //   this.selectConfig = data
    // },
    // handleCloseConfigTypeDrawer () {
    //   this.configDetailDrawer = false
    // },
    createConfigDialogOpen () {
      this.setCreateConfigDialog(true)
    },
    // createYuanDialogOpen () {
    //   this.setCreateYuanDialog(true)
    // },
    // changeMitrKubAchaaTeeverlehUneDialogOpen () {
    //   this.setChangeMitrKubAchaaTeeverlehUneDialog(true)
    // },
    // changeTeeveriinUneTootsoolohDoodJinDialogOpen () {
    //   this.setChangeTeeveriinUneTootsoolohDoodJinDialog(true)
    // },
    changeDataOpen (data) {
      this.shiljvvlehUtga = data
      this.setChangeDataDialog(true)
    },
    changeDoodJinTootsohDunDialogOpen () {
      this.setChangeDoodJinTootsohDunDialog(true)
    },
    changeHereglegchTootsohDunDialogOpen () {
      this.setChangeHereglegchTootsohDunDialog(true)
    },
    updateStatusData () {
      if (this.data.length > 0) {
        const firstItem = this.data[0] // Эхний элемент байгааг шалгана
        this.statsData = [{
          value: firstItem.yuan || 0
        },
        {
          value: firstItem.teevriin_huls || 0
        },
        {
          value: firstItem.minimum_hemjee || 0
        },
        {
          value: firstItem.minimum_amount || 0
        }
        ]
      } else {
        console.warn('Хоосон өгөгдөл байна, статистик шинэчлэгдэхгүй.')
        this.statsData = [{
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        },
        {
          value: 0
        }
        ]
      }
    },
    async changeStatus (data) {
      try {
        const response = await services.update('configsYuan', data)
        if (response && response.data) {
          ElMessage.success('Төлөв амжилттай өөрчлөгдлөө!')
        }
      } catch (error) {
        console.error('Aldaa: ', error.message)
        this.$message.error(error.message)
      }
    },
    async getActiveConfig (data) {
      try {
        const response = await services.get(`config/${data}`)
        if (response) {
          this.active_config = response.data
        }
      } catch (error) {
        console.error('Aldaa: ', error.message)
        this.$message.error(error.message)
      }
    }
  }
}

</script>

<style scoped>
/* Dashboard Container */
.dashboard-container {
  padding: 24px;
}

/* Dashboard Header */
.dashboard-header {
  margin-bottom: 32px;
  padding: 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);
  color: white;
}

.welcome-title {
  font-size: 32px;
  font-weight: 700;
  margin: 0 0 8px 0;
  color: white;
}

.user-name {
  color: #ffd700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.welcome-subtitle {
  font-size: 16px;
  margin: 0;
  opacity: 0.9;
}

/* Stats Row */
.stats-row {
  margin-bottom: 32px;
}

/* Stat Cards */
.stat-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 20px;
  height: 100%;
  min-height: 140px;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.stat-card-primary {
  border-left: 4px solid #667eea;
}

.stat-card-success {
  border-left: 4px solid #10b981;
}

.stat-icon {
  width: 64px;
  height: 64px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  flex-shrink: 0;
}

.stat-icon-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.stat-icon-success {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
}

.stat-content {
  flex: 1;
}

.stat-value {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.4;
}

/* Config History Card */
.config-history-card {
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: none;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card-title {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  display: flex;
  align-items: center;
  gap: 8px;
}

.card-title-icon {
  color: #667eea;
}

/* Modern Table */
.modern-table {
  border-radius: 8px;
  overflow: hidden;
}

.modern-table :deep(.el-table__header) {
  background: #f9fafb;
}

.modern-table :deep(.el-table__header th) {
  background: #f9fafb;
  color: #374151;
  font-weight: 600;
  border-bottom: 2px solid #e5e7eb;
}

.modern-table :deep(.el-table__body tr:hover) {
  background: #f3f4f6;
}

.modern-pagination {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

.card-footer {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

.add-button {
  border-radius: 8px;
  padding: 12px 24px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  transition: all 0.3s ease;
}

.add-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.button-icon {
  margin-right: 8px;
}

/* Table Styles */
.el-table .warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-9);
}

.el-table tr {
  --el-table-tr-bg-color: green;
}

.no-wrap {
  white-space: normal;
  display: flex;
}

.font_family {
  font-family: 'Arial', sans-serif;
}

.cusor {
  cursor: pointer;
}

.config_detail_area {
  text-align: center;
}

.config_detail_area span {
  color: gray;
}

.config_name {
  font-size: 18px;
  color: blue;
  font-weight: bold;
}

/* Responsive */
@media (max-width: 768px) {
  .dashboard-container {
    padding: 12px;
  }

  .dashboard-header {
    padding: 16px;
    margin-bottom: 20px;
  }

  .welcome-title {
    font-size: 20px;
  }

  .welcome-subtitle {
    font-size: 14px;
  }

  .stats-row {
    margin-bottom: 20px;
  }

  .stat-card {
    flex-direction: column;
    text-align: center;
    min-height: 120px;
    padding: 16px;
  }

  .stat-icon {
    width: 48px;
    height: 48px;
    font-size: 20px;
  }

  .stat-value {
    font-size: 20px;
  }

  .stat-label {
    font-size: 12px;
  }

  .config-history-card {
    margin-top: 16px;
  }

  .card-title {
    font-size: 16px;
  }

  /* Mobile Table Scroll */
  .config-history-card {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .modern-table {
    min-width: 600px;
  }
}

@media (max-width: 480px) {
  .dashboard-container {
    padding: 8px;
  }

  .dashboard-header {
    padding: 12px;
  }

  .welcome-title {
    font-size: 18px;
  }

  .stat-card {
    min-height: 100px;
    padding: 12px;
  }

  .stat-icon {
    width: 40px;
    height: 40px;
    font-size: 18px;
  }

  .stat-value {
    font-size: 18px;
  }

  .stat-label {
    font-size: 11px;
  }
}
</style>
